attachEvent('.important-info__close', 'click', (ev) => {
  const searchParent = ev.target.closest('.important-info');
  searchParent.style.display = 'none';
  Cookies.set('inportant-info-seen', 'cookie-set', { expires: 7 });
  ev.preventDefault();
});

const importantInfo = document.querySelector('.important-info');

if (importantInfo) {
  document.body.classList.add('has-important-info');
  const bodyWithInfo = document.querySelector('.has-important-info');

  const infoHeight = `${importantInfo.offsetHeight}px`;
  bodyWithInfo.marginTop = infoHeight;

  const header = document.querySelector('.header-main');
  header.style.marginTop = infoHeight;

  const logo = document.querySelector('.header-main__logo-wrapper');
  logo.style.top = infoHeight;

  const importantScroll = () => {
    importantInfo.style.height = infoHeight;

    const topOffset = document.documentElement.scrollTop || document.body.scrollTop;

    if (topOffset > 50) {
      importantInfo.style.height = '0px';
      bodyWithInfo.style.marginTop = '0px';
      logo.style.top = '0px';
      header.style.marginTop = '0px';
    } else {
      importantInfo.style.height = infoHeight;
      bodyWithInfo.style.marginTop = infoHeight;
      logo.style.top = infoHeight;
      header.style.marginTop = infoHeight;
    }
  };

  const importantClose = importantInfo.querySelector('.icon-cross');
  importantClose.addEventListener('click', () => {
    importantInfo.style.height = '0px';
    bodyWithInfo.style.marginTop = '0px';
    logo.style.top = '0px';
    header.style.marginTop = '0px';

    setTimeout(() => {
      importantInfo.style.display = 'none';
      document.body.classList.remove('has-important-info');
      document.body.classList.add('no-margin');
      logo.classList.add('no-top');
      header.classList.add('no-margin');
    }, 300);
  });

  importantScroll();
  window.addEventListener('scroll', importantScroll);
}
